import BankCard from './BankCard'

export default BankCard
